// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React from 'react';
import {Map} from '../../../../toolip/pub/ui/landings/map';
import styles from './global.module.less';

export const Global = ()=>{
    return <section className={styles.global}>
      <h2>Truly Global Network</h2>
      <div className={styles.container}>
        <div className={styles.map}><Map shown_in_home={true}/></div>
      </div>
    </section>;
};
